const formatDate = (columns: { dataField: string; dataType?: string }[], filter: unknown): void => {
  if (!Array.isArray(filter) || typeof filter[0] !== 'string') return;

  const column = columns.find((e) => e.dataField === filter[0]);
  if (column?.dataType !== 'date') return;

  if (filter.length < 3 || filter[2] === null) return;

  const parsed = new Date(filter[2] as string | number | Date);
  if (Number.isNaN(parsed.getTime())) return;

  filter[2] = parsed.toLocaleDateString('zh-CN');
};

// A condition is ["field", "operator", value]; anything else nested here is a sub-group (e.g. an OR-group).
const isCondition = (f: any): boolean => Array.isArray(f) && typeof f[0] === 'string';

export const clearFilters = (
  queryFilters: any,
  columns: { dataField: string; dataType?: string }[],
): { filtersClean: any[]; filterColumns: string[] } => {
  const filterColumns: string[] = [];
  if (queryFilters?.length > 0 && columns.length) {
    if (
      typeof queryFilters[0] === 'string' &&
      columns.some((e) => e.dataField === queryFilters[0])
    ) {
      formatDate(columns, queryFilters);
      filterColumns.push(queryFilters[0]);
      return { filtersClean: [...queryFilters], filterColumns };
    } else {
      const kept: { index: number; value: any }[] = [];
      queryFilters.forEach((f: any, index: number) => {
        if (typeof f === 'string') return;

        if (Array.isArray(f) && !isCondition(f)) {
          // Nested sub-group: sanitize recursively instead of comparing it directly to a column.
          const nested = clearFilters(f, columns);
          if (nested.filtersClean.length > 0) {
            filterColumns.push(...nested.filterColumns);
            kept.push({ index, value: nested.filtersClean });
          }
          return;
        }

        if (isCondition(f) && columns.some((e) => e.dataField === f[0])) {
          formatDate(columns, f);
          filterColumns.push(f[0]);
          kept.push({ index, value: f });
        }
      });

      if (kept.length === 1) {
        return { filtersClean: [...kept[0].value], filterColumns };
      } else if (kept.length > 1) {
        const filtersWithAnd: any[] = [];
        kept.forEach((entry, i) => {
          filtersWithAnd.push(entry.value);

          if (i < kept.length - 1) {
            const operator =
              typeof queryFilters[entry.index + 1] === 'string'
                ? queryFilters[entry.index + 1]
                : 'AND';
            filtersWithAnd.push(operator);
          }
        });
        return { filtersClean: filtersWithAnd, filterColumns };
      }
    }
  }
  return { filtersClean: [], filterColumns };
};
